module.exports = __webpack_public_path__ + "media/assets/images/front/img-front-2c-871cf49aeb888aff2833eb406978cce8.png";